import moment from 'moment';

import { IMandatory } from '~/src/dash/components/live_logs/live-logs-general-table';

// compare the stringified version of the live logs to the search field (case-insensitive)
export function filterLiveLogs<TRow extends IMandatory>(
  liveLogs: TRow[],
  searchFilter: string,
  keysToSearch?: string[],
): TRow[] {
  if (!liveLogs) {
    return [];
  }

  // globally update the bidder type to reflect the type shown on the bidder list view
  liveLogs = liveLogs.map((liveLog) => {
    if (liveLog.bidderType === 'publica') {
      return Object.assign(liveLog, { bidderType: 'vast' });
    } else if (liveLog.bidderType === 'publicaCampaign') {
      return Object.assign(liveLog, { bidderType: 'directCampaign' });
    } else {
      return liveLog;
    }
  });

  const searchFilterLower = searchFilter.toLowerCase();
  return liveLogs.filter((liveLog: TRow) => {
    const mappedLiveLog = {
      ...liveLog,
      timestamp: moment(liveLog.timestamp).format('DD-MM-YYYY HH:mm:ss'),
    };

    let liveLogStr, liveLogStrLower;
    if (!keysToSearch || !keysToSearch.length) {
      liveLogStr = JSON.stringify(mappedLiveLog);
      liveLogStrLower = liveLogStr.toLowerCase();
      return liveLogStrLower.includes(searchFilterLower);
    } else {
      const searchLiveLog: { [key: string]: any } = {};
      for (const key of Object.keys(mappedLiveLog)) {
        if (keysToSearch.includes(key)) {
          searchLiveLog[key] = mappedLiveLog[key];
        }
      }
      liveLogStr = JSON.stringify(searchLiveLog);
      liveLogStrLower = liveLogStr.toLowerCase();
    }

    return liveLogStrLower.includes(searchFilterLower);
  });
}
